import React, {useLayoutEffect, useRef, useState} from 'react';
import styles from './styles';
import {ToggleSwitch} from '@xpertdox_js/xdcomponents';
import CommentForm from './CommentForm';
import config from '../../../config/axios.config';
import axios from 'axios';
import { trackError } from '../../../utils/activityTracker'
import { UserContext } from '../../../Context/UserContext'

const ExcludeTrialDropdown = props => {

  const excludedVal = props.data.excluded.toLowerCase();
  const { user, userAction } = React.useContext(UserContext)

  const [exclude, setExclude] = useState(excludedVal === 'yes'
    ? true
    : excludedVal === 'no'
    ? false
    : props.data.excluded);


  // save changes
  const handlePostEvent = (postObject) => {
    console.log(postObject);
    const {comment, title, exclude, instance, nct, user} = postObject;
    // axios.post({
    //   method: 'post',
    //   url: `${config.apiUrl}/rt/console/saveExcluded/${postObject.user.email}`,
    //   data: postObject,
    // }).then(res => {
    //   console.log(res);
    // }).catch(err => {
    //   console.error(err);
    // })
    axios.post(
      `${config.apiUrl}/rt/console/saveExcluded/${postObject.user.email}`,
      {instance, title, exclude, nct, comment, user}
    ).then(res => {
      props.dataRefresh(props.memo);
    }).catch(err => {
      console.error(err);
      trackError({ error: err, history: props.history })
      if (err && err.response && err.response.status === 403) {
        userAction({type: 'logout'})
      }
      // TODO: handle error feedback for user
    })
  }

  const elemRef = useRef();
  useLayoutEffect(() => {
    if (elemRef.current) {
      props.measureCallback(elemRef.current);
    }
  }, [exclude]);

  return(
    <div style={styles.container} ref={elemRef}>
      <div style={styles.textAndSwitch}>
        <div style={styles.tasText}>
          <p style={styles.title}>{props.data.title}</p>
        </div>
        <div style={styles.tasSwitch}>
          <span style={styles.tipText}>Exclude Trial?</span>
          <ToggleSwitch
            condition={exclude}
            setter={setExclude}
            styles={styles.switchStyles}
          />
        </div>
      </div>
      {/* Comment Form & save button */}
      <CommentForm
        data={props.data}
        exclude={exclude}
        handlePostEvent={handlePostEvent}
      />
    </div>
  )
}


export default ExcludeTrialDropdown;
